export default "__VITE_ASSET__Cn6UKQKQ__"